export default __webpack_public_path__ + "static/media/membership-card.2b5c6919.svg";